module.exports = ".border-btm-dashed {\r\n  border-bottom: 1px dashed #e9e9e9;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.css
// module id = ./src/app/components/header/header.component.css
// module chunks = main